module.exports = __webpack_public_path__ + "static/media/added-to-gallery.0b9af421.svg";